<template>
    <div class="select-box">
        <el-select v-model="store_id" placeholder="请选择门店" clearable class="select">
            <el-option label="所有门店" value=""></el-option>
            <el-option
                    v-for="store in chainStoreArr"
                    :key="store.id"
                    :label="store.store_name"
                    :value="store.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        name: "ChainStoreSelect",
        model:{
            prop: "value",
            event: "valueChange"
        },
        props:{
            value: {
                type: String,
                default: ""
            }
        },
        data(){
            return {
                store_id: "",
                chainStoreArr: []
            };
        },
        mounted(){
            this.loadChainStore();
        },
        methods:{
            //加载所有门店
            loadChainStore() {
                this.$root.postData("chain/get_child_store_list_short", {}, res => {
                    if(res.errcode === 0){
                        this.chainStoreArr = res.data;
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            }
        },
        watch: {
            value(val){
                this.store_id = val;
            },
            store_id(val){
                this.$emit("valueChange", val);
            }
        }
    }
</script>

<style scoped>
    .select-box{
        display: inline-block;
    }
</style>
